/* eslint-disable camelcase */
import * as _braze from '@braze/web-sdk'
import constant from '@/common/resources/constant'
import { getUserExternalId } from './braze.util'

/**
 * initialize API Key값 - 개발 환경마다 상이
 *
 * as-is: 배포 브랜치에 따라 다른 API Key 삽입
 * to-be: 추후 브랜치가 아닌 빌드 환경에 따라 다른 API Key를 넣어주도록 세팅 작업이 필요합니다.
 */
class Braze {
  constructor () {
    this.braze = _braze
  }
  initialize () {
    this.braze.initialize(constant.BRAZE_PRD_API_KEY, {
      baseUrl: 'sdk.iad-06.braze.com',
      enableLogging: true
    })
  }
  changeUser (externalId) {
    const id = externalId || getUserExternalId()
    if (id !== 'none') {
      this.braze.changeUser(id)
    }
  }
  openSession () {
    this.braze.openSession()
  }
  getUserId () {
    return this.braze.getUser().getUserId()
  }
  connectUser (externalId) {
    if (this.getUserId() !== externalId) {
      this.changeUser(externalId)
    }
    this.openSession()
  }
  purchase (eventProperties) {
    const { product_id, price, currency } = eventProperties
    this.braze.logPurchase(product_id, price, currency, 1, {
      ...eventProperties
    })
  }
  contentView (eventProperties) {
    this.braze.logCustomEvent(constant.BRAZE_EVENT_CONTENT_VIEW, {
      ...eventProperties
    })
  }
}

const braze = new Braze()
export default braze
